import { render, staticRenderFns } from "./LiveChatFloatingText.vue?vue&type=template&id=5dc34f76&scoped=true&"
import script from "./LiveChatFloatingText.vue?vue&type=script&lang=js&"
export * from "./LiveChatFloatingText.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatFloatingText.vue?vue&type=style&index=0&id=5dc34f76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc34f76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VExpandTransition,VSelect,VSwitch})
